// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function assert(condition: any, msg?: string): asserts condition {
    if (!condition) {
        throw new Error(msg);
    }
}

export function assertUnreachable(value: never): asserts value {
    assert(false, `Reached unreachable value ${value}`);
}
